import { Download } from "lucide-react";
import React, { useEffect } from "react";
import { ActionIcon, Loader } from "@mantine/core";
import { HttpClientError } from "../../../providers/HttpClient";
import useExportAnnouncementEmployeeDataApiService from "../services/api/ExportAnnouncementEmployeeDataApiService";
import { useToasts } from "../../../providers/notifications/ToastsContext";

type ExportAnnouncementEmployeeDataActionIconProps = {
  id: number;
};
const ExportAnnouncementEmployeeDataActionIcon: React.FC<
  ExportAnnouncementEmployeeDataActionIconProps
> = ({ id }) => {
  const { showToast } = useToasts();
  const { isLoading, isError, error, isSuccess, mutate, data } =
    useExportAnnouncementEmployeeDataApiService();

  useEffect(() => {
    if (isError) {
      showToast({
        strapiId: "announement_export_failed",
        data: {
          message: HttpClientError(error),
        },
      });
    }
  }, [isError, error]);

  useEffect(() => {
    if (isSuccess) {
      const { filename, data: content } = data;
      const csvLink = document.createElement("a");
      csvLink.href = `data:text/csv;charset=utf-8,${encodeURI(content)}`;
      csvLink.target = "_blank";
      csvLink.download = filename;
      csvLink.click();

      showToast({ strapiId: "announement_export_success" });
    }
  }, [isSuccess, data]);

  return (
    <ActionIcon onClick={() => mutate(id)}>
      {isLoading ? <Loader size={18} /> : <Download size={18} />}
    </ActionIcon>
  );
};

export default ExportAnnouncementEmployeeDataActionIcon;
